import React, { useEffect } from "react";
import CafetariaIn from "./cafetariaIn";

const Cafetaria = () => {
  useEffect(() => {
    // 👇️ scroll to top on page load
    window.scrollTo({ top: 0, left: 0, behavior: "auto" });
  }, []);
  return (
    <div className="margem">
      <CafetariaIn />
    </div>
  );
};

export default Cafetaria;
